const googlePoint = (x, y) => ({ x, y })
const googleSize = (width, height) => ({ width, height, f: 'px', b: 'px' })

export { googlePoint, googleSize }



// WEBPACK FOOTER //
// ./src/assets/js/map/googleMaps.js